import React, {Component} from 'react';
import {Image} from 'react-konva';

/** @class BoothIcon
  * A component representing a single booth in
  * the hall.  Clicking on it opens the booth's
  * contents.
  */
export default class BoothIcon extends Component {
  /** @constructor
    * Creates a new BoothIcon
    */
  constructor(props) {
    super(props);
    this.state = {
      image: null,
      width: 0,
      height: 0
    }
  }
  /** @method componentDidMount
    * Loads the image.
    */
  componentDidMount() {
    var image = new window.Image();
    image.onload = () => {
      this.setState({
        id: 1,
        image: image,
        width: image.width * this.props.scale,
        height: image.height * this.props.scale
      });
    }
    image.src = this.props.icon;
  }
  /** @method render
    * Renders the BoothIcon
    */
  render() {
    return (
      <Image image={this.state.image}
        ref={icon => {this.icon = icon}}
        x={this.props.x}
        y={this.props.y}
        width={this.state.width}
        height={this.state.height}
        transformsEnabled="position"
        onMouseEnter={()=>{
          document.body.style.cursor = 'pointer';
        }}
        onMouseLeave={()=>{
          document.body.style.cursor = 'default';
        }}
        onClick={()=>{
          if(this.props.boothURL)
            window.location.hash = this.props.boothURL;
        }}
        onTap={()=>{
          if(this.props.boothURL)
            window.location.hash = this.props.boothURL;
        }}
        />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/booth-preview/booth-icon.js